import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, inject } from '@angular/core'
import { Router } from '@angular/router'

import { ApiPreofferService } from '@data/services/modules/preoffer/api-preoffer.service'
import { AuthService } from '@data/services/modules/auth/auth.service'
import { PreofferSummary } from '@data/interfaces/preoffer.interface'
import { PreofferView, preofferView } from '../preoffer-view.util'

interface ClientPreofferRow {
  preoffer: PreofferSummary
  view: PreofferView | null
}

/**
 * Plan v4.3 §9.3 y §2b · Renglón «Preoferta» de la ficha del cliente: su vigente (D-72), con enlace a la Calculadora del
 * expediente, donde está la tarjeta completa con el PDF y «Reenviar». Sin preoferta o sin el módulo, no se pinta.
 */
@Component({
  selector: 'app-client-preoffers',
  templateUrl: './client-preoffers.component.html',
  styleUrls: ['./client-preoffers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientPreoffersComponent implements OnChanges {
  @Input() clientId: string | null = null

  private readonly api = inject(ApiPreofferService)
  private readonly cdr = inject(ChangeDetectorRef)
  private readonly router = inject(Router)
  readonly canView = inject(AuthService).hasModulePermission('lease-preoffer', 'view')
  rows: ClientPreofferRow[] = []

  ngOnChanges(): void {
    this.rows = []
    if (!this.clientId || !this.canView) return
    this.api.byClient(this.clientId).subscribe((response) => {
      const current = response.data?.current
      this.rows = current ? [{ preoffer: current, view: preofferView(current) }] : []
      this.cdr.markForCheck()
    })
  }

  //* A «Análisis Fiscal CIEC → Calculadora» del mismo expediente.
  open(): void {
    this.router.navigate(['/customer', this.clientId], { queryParams: { tab: 'ciec', subtab: 'calculator' } })
  }
}
